import { render, staticRenderFns } from "./CustomersitelistSidebar.vue?vue&type=template&id=4136180e&scoped=true"
import script from "./CustomersitelistSidebar.vue?vue&type=script&lang=js"
export * from "./CustomersitelistSidebar.vue?vue&type=script&lang=js"
import style0 from "./CustomersitelistSidebar.vue?vue&type=style&index=0&id=4136180e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4136180e",
  null
  
)

export default component.exports